import { render, staticRenderFns } from "./commonEmpty.vue?vue&type=template&id=80457780&scoped=true"
import script from "./commonEmpty.vue?vue&type=script&lang=js"
export * from "./commonEmpty.vue?vue&type=script&lang=js"
import style0 from "./commonEmpty.vue?vue&type=style&index=0&id=80457780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80457780",
  null
  
)

export default component.exports